'use client';

import { Box, Button } from '@chakra-ui/react';
import {
  MenuContent,
  MenuItem as DropdownItem,
  MenuRoot,
  MenuTrigger,
} from '@/components/ui/menu';
import { ChevronDown } from 'lucide-react';
import { matchesShipperCategory } from '@/_lib/filter-slugs';
import type { ShipperCategory } from '../utils';
import { getCategoryLabel } from '../utils';

interface CategoryFiltersProps {
  activeCategory: string;
  visibleCategories: ShipperCategory[];
  hiddenCategories: ShipperCategory[];
  hiddenActive?: ShipperCategory;
  locale: string;
  onSelect: (categoryId: string) => void;
  allLabel: string;
  moreLabel: string;
}

const CategoryFilters = ({
  activeCategory,
  visibleCategories,
  hiddenCategories,
  hiddenActive,
  locale,
  onSelect,
  allLabel,
  moreLabel,
}: CategoryFiltersProps) => (
  <Box bg='gray.400' rounded={12} p={2}>
    <Box
      gap={3}
      display='flex'
      alignItems='center'
      flexWrap={{ base: 'wrap', md: 'nowrap' }}
    >
      <Button
        p={2}
        size='sm'
        rounded={8}
        variant='ghost'
        fontWeight={400}
        fontSize={'md'}
        onClick={() => onSelect('all')}
        bg={activeCategory === 'all' ? 'white' : 'transparent'}
        color={activeCategory === 'all' ? 'black' : 'inherit'}
      >
        {allLabel}
      </Button>
      {visibleCategories.map((category) => {
        const isActive = matchesShipperCategory(activeCategory, category);
        return (
          <Button
            p={2}
            size='sm'
            rounded={8}
            variant='ghost'
            fontSize={'md'}
            fontWeight={400}
            key={category.id}
            color={isActive ? 'black' : 'inherit'}
            bg={isActive ? 'white' : 'transparent'}
            onClick={() => onSelect(category.id)}
          >
            {getCategoryLabel(category, locale)}
          </Button>
        );
      })}
      {hiddenCategories.length > 0 && (
        <MenuRoot>
          <MenuTrigger asChild>
            <Button
              p={2}
              size='sm'
              rounded={8}
              fontSize={'md'}
              variant='ghost'
              fontWeight={400}
              bg={hiddenActive ? 'white' : 'transparent'}
              color={hiddenActive ? 'black' : 'inherit'}
            >
              {hiddenActive
                ? getCategoryLabel(hiddenActive, locale)
                : moreLabel}
              <ChevronDown />
            </Button>
          </MenuTrigger>
          <MenuContent>
            {hiddenCategories.map((category) => (
              <DropdownItem
                key={category.id}
                value={category.id}
                cursor={'pointer'}
                onClick={() => onSelect(category.id)}
              >
                {getCategoryLabel(category, locale)}
              </DropdownItem>
            ))}
          </MenuContent>
        </MenuRoot>
      )}
    </Box>
  </Box>
);

export default CategoryFilters;
